import { PostponeStepSchema } from '@feedyou-ai/feedbot-schema'
import { Mutable } from '@feedyou/utils'
import { Action, actionTypes } from './actions'

export function postponeReducer(step: Mutable<PostponeStepSchema>, action: Action) {
  switch (action.type) {
    case actionTypes.SET_POSTPONE:
      return { ...step, postpone: action.postpone }

    case actionTypes.SET_DIALOG:
      return { ...step, dialog: action.dialogId }

    default:
      return step
  }
}
